import { formatMonthYear } from '@/lib/format';
import { PetTypeEnum, getEnumTranslationByKey } from '@/shared/enums';

import { R, format } from '@/caregiverSpace/resources/Texts.resx';

import {
    formatNationalIdentifierText,
    getAgeInYearsAndMonths,
} from '@/caregiverSpace/shared/lib';
import {
    IPatientPropertiesDto,
    PropertyObjectType,
    PropertyType,
} from '@/caregiverSpace/shared/model';

import { NationalIdentifierView } from '../ui/NationalIdentifierView';

export const convertPatientPropertiesToPropertyObjectTypes = (
    patientProperties: IPatientPropertiesDto,
): PropertyObjectType[] => {
    const properties: PropertyObjectType[] = [];

    if (patientProperties.Name) {
        properties.push({
            label: R.Patient,
            value: patientProperties.Name,
            type: PropertyType.TEXT,
        });
    }

    if (patientProperties.NationalIdentifier) {
        properties.push({
            label: formatNationalIdentifierText(R.NationalIdentifier),
            value: (
                <NationalIdentifierView
                    nationalIdentifier={patientProperties.NationalIdentifier}
                    birthdate={patientProperties.Birthdate}
                />
            ),
            type: PropertyType.CUSTOM,
        });
    }

    if (patientProperties.ContactPersonName) {
        properties.push({
            label: R.ContactPerson,
            value: patientProperties.ContactPersonName,
            type: PropertyType.TEXT,
        });
    }

    if (patientProperties.Type !== null) {
        properties.push({
            label: R.PetType,
            value: getEnumTranslationByKey(PetTypeEnum, patientProperties.Type),
            type: PropertyType.TEXT,
        });
    }

    if (patientProperties.Birthdate && patientProperties.IsPet) {
        properties.push({
            label: R.Birthdate,
            value: format(
                R.BirthdateWithAge,
                formatMonthYear(patientProperties.Birthdate),
                getAgeInYearsAndMonths(patientProperties.Birthdate),
            ),
            type: PropertyType.TEXT,
        });
    }

    if (patientProperties.Race) {
        properties.push({
            label: R.Race,
            value: patientProperties.Race,
            type: PropertyType.TEXT,
        });
    }

    return properties;
};
